import React, { Component } from "react";
import "./ScheduleEntry.css";

import HeaderCard from "./HeaderCard";

class PaymentHeader extends Component {
  render() {
    const {
      TotalPayments,
      UsedAmount,
      NetUsed,
      AmountOfCPenalty
    } = this.props.header;
    return (
      <div className="schedule-class-wrapper">
        <div className="schedule-class">
          <HeaderCard
            headerClass="red half"
            headerLabel="Payments Made"
            headerValue={TotalPayments}
          />
          <HeaderCard
            headerClass="cyan half"
            headerLabel="Amount Used"
            headerValue={UsedAmount}
          />
          <HeaderCard
            headerClass="green half"
            headerLabel="Unused Credit"
            headerValue={NetUsed}
          />
          <HeaderCard
            headerClass="magenta half"
            headerLabel="Penalties"
            headerValue={AmountOfCPenalty}
          />
        </div>
      </div>
    );
  }
}

export default PaymentHeader;
